import React, { useEffect, useState } from 'react';
import { SearchIcon, XIcon, CheckIcon } from 'lucide-react';
// Sample vendor data - in a real application, this would come from an API or context
const sampleVendors = [{
  id: 'V001',
  name: 'Office Depot',
  country: 'United States',
  taxId: 'US-123456789',
  address: '2200 Old Germantown Rd, Delray Beach, FL 33445',
  email: 'accounts@officedepot.com'
}, {
  id: 'V002',
  name: 'Dell Technologies',
  country: 'United States',
  taxId: 'US-987654321',
  address: '1 Dell Way, Round Rock, TX 78682',
  email: 'accounts@dell.com'
}, {
  id: 'V003',
  name: 'PrintWorks Inc.',
  country: 'Canada',
  taxId: 'CA-456789123',
  address: '123 Printing Lane, Toronto, ON M5V 2K1',
  email: 'billing@printworks.ca'
}, {
  id: 'V004',
  name: 'Server Solutions Inc.',
  country: 'United Kingdom',
  taxId: 'GB-789123456',
  address: '45 Tech Park, London, EC1A 1BB',
  email: 'accounts@serversolutions.co.uk'
}, {
  id: 'V005',
  name: 'Global Supplies Co.',
  country: 'Australia',
  taxId: 'AU-321654987',
  address: '78 Supply Drive, Sydney, NSW 2000',
  email: 'finance@globalsupplies.com.au'
}, {
  id: 'V006',
  name: 'Tech Innovations Ltd',
  country: 'Germany',
  taxId: 'DE-159753468',
  address: 'Innovationstrasse 42, Berlin, 10115',
  email: 'accounting@techinnovations.de'
}, {
  id: 'V007',
  name: 'Office Furniture Plus',
  country: 'United States',
  taxId: 'US-753159852',
  address: '789 Comfort Ave, Chicago, IL 60601',
  email: 'billing@officefurnitureplus.com'
}, {
  id: 'V008',
  name: 'Digital Solutions GmbH',
  country: 'Germany',
  taxId: 'DE-852741963',
  address: 'Digitalweg 15, Munich, 80331',
  email: 'finance@digitalsolutions.de'
}, {
  id: 'V009',
  name: 'Paper Supplies Ltd',
  country: 'United Kingdom',
  taxId: 'GB-369258147',
  address: '22 Stationery Road, Manchester, M1 1AE',
  email: 'accounts@papersupplies.co.uk'
}, {
  id: 'V010',
  name: 'Global Tech Partners',
  country: 'Singapore',
  taxId: 'SG-147258369',
  address: '8 Technology Park, Singapore, 486123',
  email: 'finance@globaltechpartners.sg'
}];
export function VendorLookupModal({
  isOpen,
  onClose,
  onSelectVendor
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [vendors, setVendors] = useState(sampleVendors);
  const [filteredVendors, setFilteredVendors] = useState(sampleVendors);
  useEffect(() => {
    // Filter vendors based on search term
    if (searchTerm) {
      const filtered = vendors.filter(vendor => vendor.name.toLowerCase().includes(searchTerm.toLowerCase()) || vendor.id.toLowerCase().includes(searchTerm.toLowerCase()) || vendor.country.toLowerCase().includes(searchTerm.toLowerCase()));
      setFilteredVendors(filtered);
    } else {
      setFilteredVendors(vendors);
    }
  }, [searchTerm, vendors]);
  // Reset search when modal opens
  useEffect(() => {
    if (isOpen) {
      setSearchTerm('');
      setFilteredVendors(vendors);
    }
  }, [isOpen, vendors]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50" data-id="element-22629">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] flex flex-col" data-id="element-22630">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-22631">
          <h2 className="text-lg font-medium" data-id="element-22632">Vendor Lookup</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-22633">
            <XIcon className="h-5 w-5" data-id="element-22634" />
          </button>
        </div>
        <div className="p-4" data-id="element-22635">
          <div className="relative rounded-md shadow-sm mb-4" data-id="element-22636">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-22637">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-22638" />
            </div>
            <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search vendors by name, ID, or country..." autoFocus data-id="element-22639" />
          </div>
          <div className="overflow-y-auto max-h-[50vh]" data-id="element-22640">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-22641">
              <thead className="bg-gray-50" data-id="element-22642">
                <tr data-id="element-22643">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-22644">
                    Vendor ID
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-22645">
                    Vendor Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-22646">
                    Country
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-22647">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-22648">
                {filteredVendors.length > 0 ? filteredVendors.map(vendor => <tr key={vendor.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => onSelectVendor(vendor)} data-id="element-22649">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-22650">
                        {vendor.id}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-22651">
                        {vendor.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-22652">
                        {vendor.country}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-22653">
                        <button onClick={e => {
                    e.stopPropagation();
                    onSelectVendor(vendor);
                  }} className="text-indigo-600 hover:text-indigo-900 inline-flex items-center" data-id="element-22654">
                          <CheckIcon className="h-4 w-4 mr-1" data-id="element-22655" />
                          Select
                        </button>
                      </td>
                    </tr>) : <tr data-id="element-22656">
                    <td colSpan={4} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-22657">
                      No vendors found matching your search criteria
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-22658">
          <button onClick={onClose} className="px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-22659">
            Cancel
          </button>
        </div>
      </div>
    </div>;
}